import { Job, TeamMember, TeamRole, User } from '@shared/models';
import { TeamMembersListItem } from '@shared/models/team-members-list-item.model';
import { TeamMembers } from '@shared/models/team-members.model';
import { User as MojoUser } from 'mojo-share-resource/lib/models/mojo-team-members';

export function convertTeamMemberListItemsToTeamMembers(list: TeamMembersListItem[]): TeamMembers {
  const teamMembers: TeamMembers = {
    recruitingManagers: [],
    hiringManagers: [],
    regularRecruiters: [],
    coordinators: [],
  };
  list.forEach((teamMember) => {
    const member = getFullNameAndId(teamMember.user);
    switch (teamMember.role) {
      case TeamRole.regularRecruiter:
        teamMembers.regularRecruiters.push(member);
        break;
      case TeamRole.recruitingManager:
        teamMembers.recruitingManagers.push(member);
        break;
      case TeamRole.hiringManager:
        teamMembers.hiringManagers.push(member);
        break;
      case TeamRole.coordinator:
        teamMembers.coordinators.push(member);
        break;
    }
  });
  return teamMembers;
}
export function convertTeamMemberListItemsToTeamMemberArray(
  list: TeamMembersListItem[],
): TeamMember[] {
  return list.map((teamMember) => convertUserToTeamMember(teamMember.user));
}

export function convertTeamMembersToTeamMembersListItem(list: TeamMember[]): TeamMembersListItem[] {
  if (!list) {
    return [];
  }
  const result: TeamMembersListItem[] = [];
  list.forEach((teamMember) => {
    result.push({
      user: {
        id: teamMember.id,
        photoId: teamMember.photoId,
        firstName: teamMember.firstName,
        lastName: teamMember.lastName,
        name: `${teamMember.firstName} ${teamMember.lastName}`,
        workPhone: null,
        mobilePhone: null,
        role: null,
        email: teamMember.email,
        locked: false,
        createdDate: teamMember.createdDate?.toString(),
        lastModifiedDate: teamMember.lastModifiedDate?.toString(),
      },
      role: teamMember.role,
      lastModifiedDate: teamMember.lastModifiedDate,
      accessLevel: teamMember.accessLevel,
    } as TeamMembersListItem);
  });
  return result;
}

export function convertMojoUserToTeamMember(user: MojoUser): TeamMember {
  return {
    id: user.id,
    name: user.name,
    firstName: user.firstName,
    lastName: user.lastName,
    photoId: user.photoId,
  } as TeamMember;
}

export function convertUserToTeamMember(user: User): TeamMember {
  return {
    id: user.id,
    name: user.name,
    firstName: user.firstName,
    lastName: user.lastName,
    photoId: user.photoId,
    email: user.email,
    createdDate: user.createdDate,
    lastModifiedDate: user.lastModifiedDate,
  } as TeamMember;
}

export function convertJobToTeamMembers(job: Job): TeamMember[] {
  const regulars: TeamMember[] = [
    ...job.regularRecruiters.map((r) => {
      r.role = TeamRole.regularRecruiter;
      return r;
    }),
  ];
  const recruitingManagers: TeamMember[] = [
    ...job.recruitingManagers.map((r) => {
      r.role = TeamRole.recruitingManager;
      return r;
    }),
  ];
  const hiringManagers: TeamMember[] = [
    ...job.hiringManagers.map((r) => {
      r.role = TeamRole.hiringManager;
      return r;
    }),
  ];
  const coordinators: TeamMember[] = [
    ...job.coordinators.map((r) => {
      r.role = TeamRole.coordinator;
      return r;
    }),
  ];
  return [...regulars, ...recruitingManagers, ...hiringManagers, ...coordinators];
}

export function getFullNameAndId(teamMember: User): TeamMember {
  return {
    firstName: teamMember.firstName,
    lastName: teamMember.lastName,
    id: teamMember.id,
  };
}
